import createIcon from '../../createIcon';

/**
 * @component @name FormatShapes
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjMgN1YxSDE3VjNIN1YxSDFWN0gzVjE3SDFWMjNIN1YyMUgxN1YyM0gyM1YxN0gyMVY3SDIzWk0zIDNINVY1SDNWM1pNNSAyMUgzVjE5SDVWMjFaTTE3IDE5SDdWMTdINVY3SDdWNUgxN1Y3SDE5VjE3SDE3VjE5Wk0yMSAyMUgxOVYxOUgyMVYyMVpNMTkgNVYzSDIxVjVIMTlaTTEzLjczIDE0SDEwLjI0TDkuNTEgMTZINy44OUwxMS4yOSA3SDEyLjY5TDE2LjEgMTZIMTQuNDdMMTMuNzMgMTRaTTEwLjY5IDEyLjc0SDEzLjNMMTIgOC45MUwxMC42OSAxMi43NFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FormatShapes = createIcon('FormatShapes', [
  [
    'path',
    {
      d: 'M23 7V1H17V3H7V1H1V7H3V17H1V23H7V21H17V23H23V17H21V7H23ZM3 3H5V5H3V3ZM5 21H3V19H5V21ZM17 19H7V17H5V7H7V5H17V7H19V17H17V19ZM21 21H19V19H21V21ZM19 5V3H21V5H19ZM13.73 14H10.24L9.51 16H7.89L11.29 7H12.69L16.1 16H14.47L13.73 14ZM10.69 12.74H13.3L12 8.91L10.69 12.74Z',
      key: '13mq41',
    },
  ],
]);

export default FormatShapes;
